import classNames from "classnames";
import { Field, Form, withFormik } from "formik";
import Button from "pages/_components/Button";
import Credential from "pages/_components/fields/credentials/Credential";
import Head from "pages/_components/Head";
import I18n from "pages/_components/I18n";
import Hint from "pages/_components/hints/Hint";
import Notification from "pages/_components/Notification";
import { bool, func, shape, string, arrayOf } from "prop-types";
import React, { Component } from "react";
import Col from "react-bootstrap/lib/Col";
import Row from "react-bootstrap/lib/Row";
import { Modal } from "react-bootstrap";
import Image from "pages/_components/Image";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { compose } from "redux";
import * as i18nUtils from "util/i18n";
import Yup from "yup";
import * as configUtils from "util/config";
import DrawerModal from "pages/_components/drawer/DrawerModal";
import Container from "pages/_components/Container";
import MainContainer from "pages/_components/MainContainer";
import { actions as ecomexActions, selectors as ecomexSelectors } from "reducers/ecomex";
import { selectors as ecomexIframeSelectors, actions as ecomexIframeActions } from "reducers/ecomexIframe";
import { selectors as sessionSelectors } from "reducers/session";
import isTokenActive from "util/token";
import { actions as TrxActions, selectors as TrxSelectors } from "reducers/transactions";
import { resizableRoute } from "pages/_components/Resizable";
import { applyEmbeddedV3ShellLayoutState, clearEmbeddedV3ShellLayoutState } from "util/v3ShellLayoutSync";
import EcomexTransactionData from "./EcomexTransactionData";
import EcomexDeleteTransaction from "./EcomexDeleteTransaction";

const FORM_ID = "transferSummary";
class EcomexConfirmTransaction extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        fetching: bool.isRequired,
        isDesktop: bool.isRequired,
        fetchingDownload: bool.isRequired,
        summary: shape({}).isRequired,
        loggedUser: shape({ userId: string.isRequired }).isRequired,
        potentialSignaturesData: arrayOf(
            shape({ typesOfSignatures: arrayOf({ signature: string, selected: bool }), liberator: string }),
        ).isRequired,
        embeddedInV3Shell: bool,
    };

    static defaultProps = {
        embeddedInV3Shell: false,
    };

    state = {
        showDrawer: false,
        displayModal: false,
        modalShownOnce: false,
        contentDrawer: "",
    };

    componentDidMount() {
        const { summary, dispatch } = this.props;
        if (!summary?.idTransaction && localStorage.getItem("flow")) {
            dispatch(push(`${JSON.parse(localStorage.getItem("flow"))}`));
        }
        if (summary?.idTransaction) {
            this.getPotentialSign();
        }
        this.setShowSnackBar();
        this.syncEmbeddedV3ShellLayout();
    }

    componentDidUpdate(prevProps) {
        const { embeddedInV3Shell, isDesktop } = this.props;
        if (
            embeddedInV3Shell &&
            (prevProps.embeddedInV3Shell !== embeddedInV3Shell || prevProps.isDesktop !== isDesktop)
        ) {
            this.syncEmbeddedV3ShellLayout();
        }
    }

    componentWillUnmount() {
        const { embeddedInV3Shell, dispatch } = this.props;
        if (embeddedInV3Shell) {
            clearEmbeddedV3ShellLayoutState(dispatch);
        }
    }

    getPotentialSign() {
        const { summary, dispatch } = this.props;
        dispatch(TrxActions.getPotentialSignaturesData(summary?.idTransaction));
    }

    syncEmbeddedV3ShellLayout = () => {
        const { dispatch, embeddedInV3Shell, isDesktop } = this.props;
        applyEmbeddedV3ShellLayoutState(dispatch, {
            embeddedInV3Shell,
            isDesktop,
            scopes: ["ecomexConfirm"],
            titleKey: "menu.ecomex",
            goBackPath: "/v3/dashboard",
        });
    };

    handleBack = () => {
        const { dispatch, embeddedInV3Shell } = this.props;
        const { modalShownOnce } = this.state;

        if (embeddedInV3Shell) {
            dispatch(push("/v3/dashboard"));
            return;
        }

        if (modalShownOnce) {
            dispatch(push(`/desktop`));
        } else {
            this.setState({ displayModal: true });
        }

        this.setState((prevState) => ({ ...prevState, modalShownOnce: true }));
    };

    setShowSnackBar = () => {
        const { dispatch, potentialSignaturesData } = this.props;
        const hasOneOrZeroSignatures =
            Array.isArray(potentialSignaturesData) &&
            potentialSignaturesData.length > 0 &&
            Array.isArray(potentialSignaturesData[0].typesOfSignatures) &&
            potentialSignaturesData[0].typesOfSignatures.length > 1;

        if (!hasOneOrZeroSignatures) {
            dispatch(ecomexActions.ecomexSetShowSnackBar());
        }
    };

    redirectToPending = () => {
        const { dispatch } = this.props;
        dispatch(push(`/pendingTransaction/list`, { from: "ecomexConfirm" }));
    };

    hideModal = () => {
        this.setState({ displayModal: false });
    };

    handleDownloadRequestPDF = () => {
        const { dispatch, summary } = this.props;
        const sequence = summary?.transactionData?.sequencePDF;
        const requestNumber = summary?.transactionData?.requestIdEcomex;

        dispatch(ecomexIframeActions.downloadEcomexTransaction(sequence, requestNumber));
    };

    closeDrawer = () => {
        this.setState((prevState) => ({ ...prevState, showDrawer: false, contentDrawer: "" }));
    };

    render() {
        const {
            isDesktop,
            fetching,
            summary,
            fetchingDownload,
            loggedUser,
            potentialSignaturesData,
            embeddedInV3Shell,
        } = this.props;
        const { showDrawer, contentDrawer, displayModal } = this.state;
        let continueButton = null;
        let deleteButton = null;
        let credentials = null;
        let tooltip = null;
        const messageToShow = configUtils.get("frontend.ecomex.confirmTransaction.text", "");
        const isSameUser = summary?.userId === loggedUser.userId;
        const isPending = summary?.idTransactionStatus === "PENDING_TOKEN";
        const hasOneOrZeroSignatures =
            Array.isArray(potentialSignaturesData) &&
            potentialSignaturesData.length > 0 &&
            Array.isArray(potentialSignaturesData[0].typesOfSignatures) &&
            potentialSignaturesData[0].typesOfSignatures.length > 1;

        if (isSameUser && isPending && !hasOneOrZeroSignatures) {
            continueButton = (
                <Col className="col-12 confirmation__content-button" lg={12} md={12} sm={12}>
                    <Row>
                        <div className="admin-content-center">
                            <Button
                                image="images/arrowRight.svg"
                                imageStyle={isDesktop ? "mr-2" : "mr-1"}
                                type="submit"
                                bsStyle="primary"
                                label="global.confirm"
                                loading={fetching}
                            />
                        </div>
                    </Row>
                </Col>
            );

            deleteButton = (
                <Col className="col-12 confirmation__content-button" lg={12} md={12} sm={12}>
                    <Row>
                        <div className="admin-content-center">
                            <Button
                                image="images/trashBlue.svg"
                                imageStyle="mr-2"
                                onClick={() =>
                                    this.setState((prevState) => ({
                                        ...prevState,
                                        showDrawer: true,
                                        contentDrawer: <EcomexDeleteTransaction />,
                                    }))
                                }
                                label="ecomex.transaction.delete.request"
                                loading={fetching}
                                className="btn-outline btn-secondary"
                            />
                        </div>
                    </Row>
                </Col>
            );

            credentials = (
                <>
                    <Row className="my-2">
                        {!isTokenActive(!isDesktop) ? (
                            <div className="admin-content-center">
                                <I18n
                                    id="transfer.summary.confirm.label"
                                    componentProps={{
                                        className: classNames("font-light", {
                                            "f-size-65": !isDesktop,
                                            "f-size-55": isDesktop,
                                        }),
                                    }}
                                />
                            </div>
                        ) : (
                            <div className="admin-content-center pb-3">
                                <I18n
                                    id="confirmation.withoutotp.text"
                                    component="p"
                                    componentProps={{ className: "confirmation__text-without-otp" }}
                                />
                            </div>
                        )}
                    </Row>
                    <Row>
                        <div className="admin-content-center">
                            <Field
                                name="otp"
                                type="otp"
                                idForm={FORM_ID}
                                component={Credential}
                                placeholderText={i18nUtils.get(`confirmation.otp.placeholder`)}
                            />
                        </div>
                    </Row>
                </>
            );
        } else if (isSameUser && isPending && hasOneOrZeroSignatures) {
            continueButton = (
                <Col className="col-12 confirmation__content-button" lg={12} md={12} sm={12}>
                    <Row>
                        <div className="admin-content-center">
                            <Button
                                image="images/arrowRight.svg"
                                imageStyle={isDesktop ? "mr-2" : "mr-1"}
                                type="submit"
                                bsStyle="primary"
                                label="global.confirm"
                                loading={fetching}
                            />
                        </div>
                    </Row>
                </Col>
            );
            credentials = (
                <>
                    <Row className="my-2">
                        {!isTokenActive(!isDesktop) ? (
                            <div className="admin-content-center">
                                <I18n
                                    id="transfer.summary.confirm.label"
                                    componentProps={{
                                        className: classNames("font-light", {
                                            "f-size-65": !isDesktop,
                                            "f-size-55": isDesktop,
                                        }),
                                    }}
                                />
                            </div>
                        ) : (
                            <div className="admin-content-center pb-3">
                                <I18n
                                    id="confirmation.withoutotp.text"
                                    component="p"
                                    componentProps={{ className: "confirmation__text-without-otp" }}
                                />
                            </div>
                        )}
                    </Row>
                    <Row>
                        <div className="admin-content-center">
                            <Field
                                name="otp"
                                type="otp"
                                idForm={FORM_ID}
                                component={Credential}
                                placeholderText={i18nUtils.get(`confirmation.otp.placeholder`)}
                            />
                        </div>
                    </Row>
                </>
            );
        } else {
            continueButton = "";
            deleteButton = "";
            credentials = "";
        }
        if (messageToShow === "undefined" || messageToShow === "") {
            tooltip = "";
        } else {
            tooltip = (
                <Hint
                    classNameGroup="d-flex align-items-center "
                    classNameHintP="m-0 mx-2"
                    defaultValue={messageToShow}
                    alwaysShowMessage
                />
            );
        }
        return (
            <>
                {displayModal && (
                    <Modal show={displayModal} className="modal-ecomex">
                        <div className="modal-container">
                            <Modal.Header closeButton onClick={this.hideModal}>
                                <Modal.Title />
                            </Modal.Header>
                            <Modal.Body>
                                <MainContainer>
                                    <div className="above-the-fold">
                                        <Container className="container--layout flex-grow align-items-center">
                                            <Col sm={12} className="col col-12">
                                                <Image src="images/warning-modal.svg" className="svg-icon mt-3" />
                                                <h3>
                                                    <I18n
                                                        component="b"
                                                        id="ecomex.transaction.handleBack.modalHeader"
                                                    />
                                                </h3>

                                                <I18n id="ecomex.transaction.handleBack.modal1" />
                                                <br />
                                                <div
                                                    role="button"
                                                    tabIndex={0}
                                                    onClick={this.redirectToPending}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter" || e.key === " ") {
                                                            e.preventDefault();
                                                            this.redirectToPending();
                                                        }
                                                    }}
                                                    style={{ cursor: "pointer" }}>
                                                    <I18n component="u" id="ecomex.transaction.handleBack.modal2" />
                                                </div>
                                            </Col>
                                        </Container>
                                        <Container className="container--layout align-items-center">
                                            <Col className="col col-12">
                                                <Button
                                                    className="btn-secondary"
                                                    label="ecomex.transaction.handleBack.modalButton"
                                                    bsStyle="primary"
                                                    onClick={this.hideModal}
                                                />
                                            </Col>
                                        </Container>
                                    </div>
                                </MainContainer>
                            </Modal.Body>
                        </div>
                    </Modal>
                )}
                {showDrawer && (
                    <DrawerModal
                        content={contentDrawer}
                        width="442px"
                        showDrawerRemote={showDrawer}
                        isDesktop={isDesktop}
                        drawerClassName="ecomex-delete-drawer"
                        closeRemotely={() => this.closeDrawer()}
                    />
                )}
                {!embeddedInV3Shell && <Notification scopeToShow="ecomexConfirm" />}
                {(!embeddedInV3Shell || isDesktop) && (
                    <div className="admin-detail-head px-0">
                        <Head
                            onBack={this.handleBack}
                            headerClassName={!isDesktop ? "blue-main-header-mobile" : ""}
                            title={!isDesktop && "menu.ecomex"}
                            centerContentClassName={classNames({
                                "mx-5": !isDesktop,
                            })}
                        />
                        {isDesktop && (
                            <div className="d-flex">
                                <div className="mx-3">
                                    <h1>{i18nUtils.get("menu.ecomex")}</h1>
                                </div>
                            </div>
                        )}
                    </div>
                )}
                <MainContainer>
                    <Form>
                        <Container
                            className={classNames("flex-grow align-items-center confirmation__container")}
                            gridClassName="form-content">
                            {!isDesktop && (
                                <div
                                    className={classNames("admin-content-center", {
                                        "mb-3": !isDesktop,
                                    })}>
                                    <I18n
                                        id="ecomex.summary.checkInfo.label"
                                        component="h2"
                                        componentProps={{ className: classNames({ "f-size-35": !isDesktop }) }}
                                    />
                                </div>
                            )}

                            <Col className="col-12 confirmation__form ecomex__confirmation__form" lg={6} md={9} sm={12}>
                                {isDesktop && (
                                    <div>
                                        <div
                                            className={classNames("admin-content-center", {
                                                "mb-3": !isDesktop,
                                            })}>
                                            <I18n
                                                id="ecomex.summary.checkInfo.label"
                                                component={!isDesktop ? "h2" : "h1"}
                                                componentProps={{ className: classNames({ "f-size-35": !isDesktop }) }}
                                            />
                                        </div>
                                    </div>
                                )}
                                <EcomexTransactionData isDesktop={isDesktop} />
                                <div
                                    className={classNames("admin-content-center", {
                                        "mb-3": !isDesktop,
                                    })}>
                                    <Button
                                        block
                                        label="ecomex.transaction.download.label"
                                        loading={fetchingDownload}
                                        image="images/download.svg"
                                        onClick={() => this.handleDownloadRequestPDF()}
                                        className="btn-outline btn-download"
                                        imageStyle="mr-2"
                                    />
                                </div>
                                <div>{tooltip}</div>

                                {credentials}
                                <Container className="flex-grow align-items-center w-100" gridClassName="form-content">
                                    {continueButton}
                                    {deleteButton}
                                </Container>
                            </Col>
                        </Container>
                    </Form>
                </MainContainer>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    summary: ecomexSelectors.getSummary(state),
    userId: sessionSelectors.getUser(state).userId,
    loggedUser: sessionSelectors.getUser(state),
    envName: sessionSelectors.getActiveEnvironment(state).name,
    fetching: ecomexSelectors.getFetching(state),
    fetchingDownload: ecomexIframeSelectors.getFetchingDownload(state),
    potentialSignaturesData: TrxSelectors.getPotentialSignaturesData(state),
});

export default compose(
    connect(mapStateToProps),
    withFormik({
        mapPropsToValues: () => ({ otp: "" }),
        validationSchema: () =>
            Yup.object().shape({
                otp: Yup.string().required(i18nUtils.get(`${FORM_ID}.otp.error.required`)),
            }),
        handleSubmit: ({ otp }, formikBag) => {
            const { dispatch, summary, userId } = formikBag.props;
            const { transactionData } = summary;
            const { requestIdEcomex } = transactionData;
            const enableNonDeductLimits = configUtils.getBoolean("frontend.ecomex.check.nonDeduct.limits", false);

            if (!enableNonDeductLimits) {
                const ecomexTransaction = {
                    userId,
                    idEnvironment: summary?.idEnvironment,
                    lang: summary?.lang,
                    channel: summary?.channel,
                    transactionData: summary?.transactionData,
                    _otp: otp,
                    idTransaction: summary?.idTransaction,
                    ecomexRequest: requestIdEcomex,
                    deleting: false,
                };
                dispatch(ecomexActions.sendAcceptOrRejectEcomexTransaction(ecomexTransaction));
            } else {
                const amount = {
                    currency: summary?.amount?.currency,
                    quantity: summary?.amount?.quantity,
                };
                const ecomexTransaction = {
                    amount,
                    debitAccount: summary?.debitAccount,
                    userId,
                    idEnvironment: summary?.idEnvironment,
                    lang: summary?.lang,
                    channel: summary?.channel,
                    transactionData: summary?.transactionData,
                    _otp: otp,
                    idTransaction: summary?.idTransaction,
                    ecomexRequest: requestIdEcomex,
                    deleting: false,
                };

                dispatch(ecomexActions.sendAcceptOrRejectEcomexTransactionNonDeduct(ecomexTransaction));
            }
        },
    }),
    resizableRoute,
)(EcomexConfirmTransaction);
